﻿import { createAction } from '@reduxjs/toolkit';

/* This function is being called with the argument `'speedcurve/trackConversion'`, which is a string
representing the name of the action. The `createAction` function is used to create an action
creator, which is a function that returns an action object with a specific type. In this case, the
action object will have a type of `'speedcurve/trackConversion'`. 

Examples:

store.dispatch(speedCurveTrackConversion([{ name: 'lead_sent', value: 1 }]))
*/
const speedCurveTrackConversion = createAction('speedcurve/trackConversion');

/* This function is being called with the argument `'speedcurve/markStart'`, which is a string
representing the name of the action. The `createAction` function is used to create an action
creator, which is a function that returns an action object with a specific type. In this case, the
action object will have a type of `'speedcurve/markStart'`. 

Examples:

store.dispatch(speedCurveMarkStart([{ name: 'map_script_start' }]))
*/
const speedCurveMarkStart = createAction('speedcurve/markStart');

/* This function is being called with the argument `'speedcurve/markEnd'`, which is a string
representing the name of the action. The `createAction` function is used to create an action
creator, which is a function that returns an action object with a specific type. In this case, the
action object will have a type of `'speedcurve/markEnd'`. 

Examples:

store.dispatch(
    speedCurveMarkEnd([
      {
        measureName: 'map_downloaded',
        markNameStart: 'map_script_start',
        markNameEnd: 'map_script_end',
      },
    ])
  );
*/
const speedCurveMarkEnd = createAction('speedcurve/markEnd');

/* This function is being called with the argument `'speedcurve/timingMetric'`, which is a string
representing the name of the action. The `createAction` function is used to create an action
creator, which is a function that returns an action object with a specific type. In this case, the
action object will have a type of `'speedcurve/timingMetric'`. 

Examples:

store.dispatch(speedcurveTimingMetric([{ name: 'srp', value: 500 }]))
*/
const speedcurveTimingMetric = createAction('speedcurve/timingMetric');

export { speedCurveTrackConversion, speedCurveMarkStart, speedCurveMarkEnd, speedcurveTimingMetric };
